import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { RouteConfig } from "vue-router/types/router";

export const committeesRoutes = (startTemplate: string): RouteConfig[] => {
    return [
        {
            path: startTemplate + '/committees',
            component: () => import(/* webpackChunkName: "committees" */ '../../views/committees/CommitteesRootView.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import(/* webpackChunkName: "committees" */ '../../views/committees/CommitteesListView.vue'),
                    name: RouteNamesEnum.committeesList,
                    meta: {
                        analyticName: 'committeesList'
                    }
                },
                {
                    path: 'create',
                    component: () => import(/* webpackChunkName: "committees" */ '../../views/committees/CommitteeFormView.vue'),
                    name: RouteNamesEnum.committeesCreate,
                    meta: {
                        analyticName: 'committeeCreate'
                    }
                },
                {
                    path: 'edit/:id',
                    component: () => import(/* webpackChunkName: "committees" */ '../../views/committees/CommitteeFormView.vue'),
                    name: RouteNamesEnum.committeesEdit,
                    meta: {
                        analyticName: 'committeeEdit'
                    }
                },
                {
                    path: 'view/:id',
                    component: () => import(/* webpackChunkName: "committees" */ '../../views/committees/CommitteeView.vue'),
                    name: RouteNamesEnum.committeesView,
                    meta: {
                        analyticName: 'committeeView'
                    }
                }
            ]
        }
    ]
}